$(document).ready(function() {
  $("img").unveil();
});

ScrollReveal().reveal('.slide-left', {
    delay: 200,
    distance: '40px',
    duration: 1000,
    origin: 'right',
    reset: true
});

ScrollReveal().reveal('.slide-right', {
    delay: 375,
    distance: '40px',
    duration: 1000,
    origin: 'left',
    reset: true
});

ScrollReveal().reveal('.base-magnifier', {
    delay: 500,
    duration: 500,
    easing: 'ease-out',
    reset: true,
    scale: .7
});
